<template>
    <div class="container afro-chic-booking" v-if="serviceData">
        
        <div class="service-detail-card">
            <!-- <div class="header-content">
                <img :src ="getImageUrl(serviceData.image)" :alt="serviceData.name" class="service-detail-image">
                <span class="service-detail-price">${{ serviceData.price }}</span>
            </div> -->

            <div class="header-content">
  <img 
    v-if="getImageUrl(serviceData.image) !== ''" 
    :src="getImageUrl(serviceData.image)" 
    :alt="serviceData.name" 
    class="service-detail-image"
  >

  <div v-else class="service-placeholder-svg">
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/1999/xlink">
        <path d="M256,16C123.45,16,16,123.45,16,256S123.45,496,256,496s240-107.45,240-240S388.55,16,256,16ZM368.41,293c-23,43.76-69,63.13-112.41,63.13H256c-48,0-80,32-80,80v8a192.17,192.17,0,0,1-112.1-344.1A191.24,191.24,0,0,1,368.41,293Z" fill="#D1D5DB"/>
        <path d="M375,190.49c-10.49-14-11.66-31.56-3.15-46.72a71.86,71.86,0,0,1,28.82-27C378,110,351,108.31,326,112.49c-32.32,5.39-58.49,26.66-68.8,55.7a47.38,47.38,0,0,0,4.82,41.48c10.48,14,11.66,31.56,3.15,46.72a71.86,71.86,0,0,1-28.82,27c22.7,6.76,49.66,8.45,74.63,4.28,32.32-5.39,58.49-26.66,68.81-55.7A47.38,47.38,0,0,0,375,190.49Z" fill="#A1A1AA"/>
        <path d="M428.16,167.35a144.11,144.11,0,0,0-53-53,170,170,0,0,0-72.37-23.77c-36.56-3-63,18.78-83.3,37a111.49,111.49,0,0,1-24.81,17.06A61.64,61.64,0,0,0,165.3,168a96,96,0,0,0-1.3,16h-3.8c-28,0-50.62,20.3-52,47v11.77a34.77,34.77,0,0,0,7.39,21.8,96.35,96.35,0,0,0,23.32,23.32,192.39,192.39,0,0,1,69.09,69.09,96.35,96.35,0,0,0,23.32,23.32,34.77,34.77,0,0,0,21.8,7.39H256c80,0,144-64,144-144,0-32-16.14-53.11-39.71-65.74A127.35,127.35,0,0,1,387,143a143.51,143.51,0,0,1,41.16,24.35Z" fill="#D1D5DB"/>
    </svg>
  </div>
  <span class="service-detail-price">${{ serviceData.price }}</span>
</div>

            <div class="body-content">
                <h2 class="service-detail-name">{{ serviceData.name }}</h2>
                <p class="service-detail-description">{{ serviceData.description }}</p>
                <p class="service-detail-duration">
                    **Duration:** {{ formatDuration(serviceData.duration) }}
                </p>
            </div>
        </div>
        
        <section class="booking-section">
    <h3 class="section-title">Enshrine Your Appointment Time</h3>
    
    <form @submit.prevent="bookService" class="booking-form-grid">
        
        <div class="form-group date-group">
            <label class="form-label">Select Date</label>
            <div class="slots-container">
                <button
                    v-for="date in uniqueDates" 
                    :key="date" 
                    :class="['slot-btn date-slot', { 'is-selected': booking.date === date }]"
                    @click.prevent="selectDate(date)"
                >
                    {{ formatDate(date) }}
                </button>
            </div>
           <p v-if="uniqueDates.length === 0" class="no-slots-msg">
                No future dates are currently available for this service.
            </p>
        </div>
        
        <div class="form-group time-group">
            <label class="form-label">Select Time Slot</label>
            <div class="slots-container">
                <button
                    v-for="slot in availableSlotsForDate" 
                    :key="slot.id" 
                    :class="['slot-btn time-slot', { 'is-selected': selectedSlot?.id === slot.id || slot_id === slot.id }]"
                    :disabled="!booking.date"
                    @click.prevent="handleSlotClick(slot)"
                >
                    <span v-if="booking.startTime && slot_id === slot.id">
                        {{ formatTime(booking.startTime) }} - {{ formatTime(booking.stopTime) }}
                    </span>
                    <span v-else>
                        {{ formatTime(slot.startTime) }} - {{ formatTime(slot.stopTime) }}
                    </span>
                </button>
               <!-- <button
    v-for="slot in availableSlotsForDate" 
    :key="slot.id" 
    :class="['slot-btn time-slot', { 'is-selected': selectedSlot?.id === slot.id || isSlotSelected(slot) }]"
    :disabled="!booking.date"
    @click.prevent="handleSlotClick(slot)"
>
    <span v-if="booking.startTime && isSlotSelected(slot)">
        {{ formatTime(booking.startTime) }} - {{ formatTime(booking.stopTime) }}
    </span>
    <span v-else>
        {{ formatTime(slot.startTime) }} - {{ formatTime(slot.stopTime) }}
    </span>
</button> -->

            </div>
            <p v-if="booking.date && availableSlotsForDate.length === 0" class="no-slots-msg">
                No time slots available for this date.
            </p>
            <p v-else-if="!booking.date" class="no-slots-msg">
                Select an available date first.
            </p>
        </div>

        <div 
            v-if="selectedSlot && booking.date" 
            class="confirmation-modal"
        >
            <h4 class="modal-heading">Confirm or Adjust Start Time</h4>
            <p class="default-slot-info">Default Slot Start: **{{ formatTime(selectedSlot.startTime) }}**</p> 
            
             <div class="input-row">
                        <label for="custom-start-time">Your Desired Start Time:</label>
                        <input 
                            type="time" 
                            id="custom-start-time"
                            v-model="customStartTime"
                            class="time-input"
                        />
                    </div>

                    <div class="modal-actions">
                        <button 
                            type="button" 
                            class="btn-confirm" 
                            @click="confirmSlotTime"
                        >
                            Affirm Time Slot
                        </button>
                        <button 
                            type="button" 
                            class="btn-cancel-small" 
                            @click="cancelSlotSelection"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
                
                <div class="action-buttons-group">
                    <button 
                        type="button" 
                        class="btn-secondary" 
                        @click="$emit('select-another-service')"
                    >
                        Change Service
                    </button>
                    
                    <button 
                        type="submit" 
                        class="submit-btn" 
                        :disabled="!booking.date || !booking.startTime"
                    >
                        Proceed to Details
                    </button>
            
            </div>

        </form>
</section>

    </div>
    <div v-else class="loading-message">Loading service details...</div>
</template>

<script>
import axios from 'axios'
const API_BASE_URL = `${process.env.VUE_APP_API_URL}/slot/`;


export default {
    name: 'SelectDnTService',
    props: {
        serviceData: {
            type: Object,
            required: true
        },
        comp: {
            type: String,
            required: true
        }
    },
    emits: ['select-another-service', 'continue-to-form'],
    data() {
        return {
            // Stores the final selection for submission
            booking: {
                date: '',
                startTime: '',
                stopTime: '' 
            },
            // Stores the raw clicked slot object to trigger the modal
            selectedSlot: null, 
            // Stores the user's input time from the modal
            customStartTime: '',
            slots: [], // stores processed slots
            slot_id: null,
            rawBackendSlots: [], // Stores the original response from the backend
        }
    },

    computed: {
        uniqueDates() {
            // 1. Map all slots to just their date strings
            const dates = this.slots.map(slot => slot.date);
            
            // 2. Filter out dates that are in the past (based on the current date)
            const today = this.formatDateForStorage(new Date()); 
            
            // 3. Use Set to get unique dates, filter for future/current dates, and sort
            return [...new Set(dates)]
                   //.filter(date => date >= today)
                   .sort();
        },
        availableSlotsForDate() {
            if (!this.booking.date) return [];
            return this.slots.filter(slot => slot.date === this.booking.date)
                .sort((a, b) => a.startTime.localeCompare(b.startTime));
        }
    },
    async created() {
        this.slots = await this.loadSlots(this.serviceData.id)
        if (this.slots.length === 0){
            console.log("No Slots present")
            console.log("Service Data id is: ", this.serviceData.id)
        }
    },
    methods: {
        formatDate(dateString) { 
            if (!dateString) return '';
            
            const [year, month, day] = dateString.split('-').map(Number);
            // Create date using local constructor (month is 0-indexed)
            const date = new Date(year, month - 1, day); 
            
            if (isNaN(date.getTime())) return dateString;

            return date.toLocaleDateString(undefined, { 
                weekday: 'short', 
                month: 'short', 
                day: 'numeric' 
            });
        },
        formatTime(timeString) { 
            const [hours, minutes] = timeString.split(':').map(Number);
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        },
        formatDuration(durationMinutes) { 
            const totalMinutes = parseInt(durationMinutes, 10);
            if (isNaN(totalMinutes) || totalMinutes <= 0) return 'Variable';
            
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            
            let parts = [];
            if (hours > 0) parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
            if (minutes > 0) parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
            
            return parts.join(' ');
        },
        isSlotSelected(slot) {
            // return this.booking.startTime === slot.startTime && this.booking.stopTime === slot.stopTime;
            return this.slot_id === slot.id
        },

        booked() {
            return !(this.booking.startTime === '')
        },

        selectDate(date) {
            // Toggle date selection
            if (this.booking.date === date) {
                this.booking.date = '';
            } else {
                this.booking.date = date;
            }
            // Reset time and modal states when date changes
            this.booking.startTime = '';
            this.booking.stopTime = '';
            this.slot_id = null;
            this.selectedSlot = null;
            this.customStartTime = '';
        },
      
        handleSlotClick(slot) {
            // 1. If the user clicks the slot that currently has its modal open, close it.
            if (this.selectedSlot && this.selectedSlot.id === slot.id) {
                this.selectedSlot = null;
                this.customStartTime = '';
                return;
            }
            this.selectedSlot = slot;
            this.customStartTime = slot.startTime; 
            this.booking.startTime = '';
            this.booking.stopTime = '';
        },


        confirmSlotTime() {
            // 1. Determine the proposed start time (user input overrides default)
            const proposedStartTime = this.customStartTime || this.selectedSlot.startTime;
            
            // 2. Calculate the proposed end time
            const proposedEndTime = this.calculateEndTime(proposedStartTime, this.serviceData.duration);
            
            // 3. --Validation Check ---
            const isTimeValid = this.validateProposedTime(
                proposedStartTime, 
                proposedEndTime, 
                this.selectedSlot.startTime, 
                this.selectedSlot.stopTime
            );

            if (!isTimeValid) {
                return; 
            }

            // 4. Update the final booking state
            this.booking.date = this.selectedSlot.date; 
            this.booking.startTime = proposedStartTime; // Use the validated proposed time
            this.booking.stopTime = proposedEndTime;
            this.slot_id = this.selectedSlot.id
            
            // 5. Close the modal/confirmation area
            this.selectedSlot = null;
        },


// Helper to convert HH:MM time string to total minutes from midnight
        timeToMinutes(timeString) {
            const [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        },

        validateProposedTime(proposedStart, proposedEnd, slotStart, slotEnd) {
            const serviceDuration = parseInt(this.serviceData.duration, 10);
            
            // Check 1: Ensure service duration is positive
            if (serviceDuration <= 0 || isNaN(serviceDuration)) {
                alert("Error: Service duration is invalid.");
                return false;
            }

            // Convert all times to minutes from midnight for easy comparison
            const proposedStartMins = this.timeToMinutes(proposedStart);
            const proposedEndMins = this.timeToMinutes(proposedEnd);
            const slotStartMins = this.timeToMinutes(slotStart);
            const slotEndMins = this.timeToMinutes(slotEnd);
            
            // Check 2: Proposed Start Time must be within the available slot range
            if (proposedStartMins < slotStartMins || proposedStartMins >= slotEndMins) {
                alert(`The chosen start time (${this.formatTime(proposedStart)}) must be within the available slot: ${this.formatTime(slotStart)} to ${this.formatTime(slotEnd)}.`);
                return false;
            }
            if (proposedEndMins > slotEndMins) {
                // Calculate maximum possible start time that fits the slot
                const maxStartMins = slotEndMins - serviceDuration;
                const maxStartHours = Math.floor(maxStartMins / 60);
                const maxStartMinutes = maxStartMins % 60;
                
                const maxStartTimeString = `${String(maxStartHours).padStart(2, '0')}:${String(maxStartMinutes).padStart(2, '0')}`;
                
                alert(`The service duration (${this.formatDuration(serviceDuration)}) does not fit if started at ${this.formatTime(proposedStart)}. The latest possible start time is ${this.formatTime(maxStartTimeString)}.`);
                return false;
            }

            return true; // All checks passed
        },

        cancelSlotSelection() {
            this.selectedSlot = null;
            this.customStartTime = '';
        },
        
        calculateEndTime(startTime, durationMinutes) {
            const [startHours, startMinutes] = startTime.split(':').map(Number);
            const totalDuration = parseInt(durationMinutes, 10);
            
            const endDate = new Date();
            endDate.setHours(startHours);
            endDate.setMinutes(startMinutes + totalDuration);

            // Return time in 'HH:MM' 24-hour format
            const endHours = String(endDate.getHours()).padStart(2, '0');
            const endMinutes = String(endDate.getMinutes()).padStart(2, '0');
            return `${endHours}:${endMinutes}`;
        },

        /*getImageUrl(filename) {
            const API_BASE_IMG = new URL(process.env.VUE_APP_API_URL).origin;
            return `${API_BASE_IMG}/uploads/services/${filename}`;
        },*/

        getImageUrl(filename) {
            console.log("The filename of the image in service is: ", filename)
            //const API_BASE = new URL(process.env.VUE_APP_API_URL).origin;
            //const placeholder = "https://placehold.co/600x400?text=No+Image+Available";

            // 2. Check if filename is null, undefined, empty string, or the string "none"
            if (!filename || filename === 'none' || filename === 'null') {
                return '';
            }
                    
                    //const path_to_file = `${API_BASE}/uploads/services/${filename}`;
                    //console.log("Actual path to file: ", path_to_file)*/
            return `https://api.kcafrobraids.com/uploads/services/${filename}`;
        },

        async loadSlots(serviceID) {
            try {
                const response = await axios.get(`${API_BASE_URL}get_slot/${serviceID}`);
                
                return response.data.map(slot => {
                    const rawDate = new Date(slot.date);
                    let dateKey = '';

                    if (isNaN(rawDate.getTime())) {
                        // If parsing failed, try to regex the YYYY-MM-DD out of the string
                        const match = slot.date.match(/\d{4}-\d{2}-\d{2}/);
                        dateKey = match ? match[0] : slot.date;
                    } else {
                        // Use UTC methods to avoid "Daylight Savings" or Timezone shifts
                        const year = rawDate.getUTCFullYear();
                        const month = String(rawDate.getUTCMonth() + 1).padStart(2, '0');
                        const day = String(rawDate.getUTCDate()).padStart(2, '0');
                        dateKey = `${year}-${month}-${day}`;
                    }

                    return {
                        id: slot.id,
                        date: dateKey,           // Clean "2026-03-03"
                        startTime: slot.start_time, // "06:00"
                        stopTime: slot.end_time || slot.stop_time, 
                        raw: slot
                    };
                });
            } catch(error) {
                console.error("Error loading slots:", error);
                return [];
            }
        },

        // --- NEW HELPER METHOD ---
        formatTimeForStorage(date) {
            // Helper to get time in HH:MM format (24hr)
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        },

        formatDateForStorage(date) {
            // Helper to get date in YYYY-MM-DD format
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        bookService() {
            // 1. Validation: Ensure we have the raw data
            if (this.booking.date && this.booking.startTime) {
                const bookingData = {
                    // Service Info
                    serviceId: this.serviceData.id,
                    serviceName: this.serviceData.name,
                    servicePrice: this.serviceData.price,
                    
                    // UI Display Info (What the user sees on the next screen)
                    displayDate: this.formatDate(this.booking.date), 
                    displayTime: `${this.formatTime(this.booking.startTime)} - ${this.formatTime(this.booking.stopTime)}`,
                    
                    slot_id: this.slot_id, 
                    
                    date: this.booking.date,           // "2026-01-30"
                    startTime: this.booking.startTime, // "09:00"
                    stopTime: this.booking.stopTime,   // "09:25"
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                };
            console.log("Emitting Booking Data:", bookingData);
                this.$emit('continue-to-form', bookingData);
            } else {
                alert('Please select a date and confirm your start time.');
            }
        }
            }
        }
</script>

<style scoped>
/* Base Layout & Containers */
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    font-family: var(--font-sans);
}

/*
1. Service Detail Card*/
.service-detail-card {
    width: 95%; 
    max-width: 950px;
    margin: 2.5rem auto;
    border: 2px solid var(--color-gold); /* Gold border for emphasis */
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15); /* Richer shadow */
    background-color: white;
    overflow: hidden;
}

.header-content {
    position: relative;
    z-index: 20;
}

.service-detail-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    max-height: 450px; 
    border-bottom: 3px solid var(--color-gold); /* Gold line under image */
}

.service-detail-price {
    position: absolute;
    bottom: 15px;
    right: 20px;
    background-color: var(--color-maroon); /* Maroon price tag */
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border-radius: 10px;
    font-size: 1.6rem;
    z-index: 20;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.body-content {
    padding: 30px;
}

.service-detail-name {
    font-family: var(--font-serif);
    font-size: 2.5rem; 
    color: var(--color-dark);
    margin-top: 0;
    margin-bottom: 15px;
    border-bottom: 2px solid var(--color-earth); /* Earth tone separator */
    padding-bottom: 10px;
}

.service-detail-description {
    font-size: 1.1rem;
    color: #444;
    line-height: 1.6;
    text-align: justify;
}

.service-detail-duration {
    font-size: 1rem;
    color: var(--color-maroon);
    font-weight: 600;
    margin-top: 15px;
    padding-top: 5px;
}

/* 
2. Booking Form Section*/
.booking-section {
    max-width: 950px;
    margin: 2.5rem auto 4rem;
    padding: 0 15px;
}

.booking-section h3 {
    font-family: var(--font-serif);
    font-size: 2rem;
    color: var(--color-earth); /* Earth tone heading */
    margin-bottom: 30px;
    text-align: center;
    border-bottom: 2px dashed var(--color-gold);
    padding-bottom: 10px;
}

/* Mobile-First: Stacked by default */
.booking-form-grid {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

/* Form Group Styling (Label on Border) */
.form-group {
    position: relative;
    border: 2px solid #ddd;
    border-radius: 10px;
    padding: 20px 20px 15px 20px; 
    background-color: #fcfcfc;
}

.form-label {
    position: absolute;
    top: -12px;
    left: 15px;
    background-color: white; 
    padding: 0 8px;
    font-size: 1rem;
    color: var(--color-maroon); /* Maroon label */
    font-weight: 700;
}

/* 3. Action Buttons Group Styling*/
.action-buttons-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.submit-btn {
    /* Primary Action (Continue) */
    background-color: var(--color-maroon);
    color: white;
    padding: 15px 25px;
    border: none;
    border-radius: 25px; /* Pill shape */
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: bold;
    transition: background-color 0.3s, transform 0.2s;
    width: 100%;
}

.submit-btn:hover:not(:disabled) {
    background-color: #4a0c19; /* Darker Maroon */
    transform: translateY(-1px);
}

.btn-secondary {
    /* Secondary Action (Select Another Service) */
    background-color: var(--color-gold);
    color: var(--color-dark);
    padding: 15px 25px;
    border: none; 
    border-radius: 25px;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: bold;
    transition: all 0.3s, transform 0.2s;
    width: 100%;
}

.btn-secondary:hover {
    background-color: #f7a000;
    color: var(--color-maroon);
    transform: translateY(-1px);
}

.submit-btn:disabled {
    background-color: #eee;
    color: #aaa;
    cursor: not-allowed;
    border: 1px solid #ddd;
    box-shadow: none;
    transform: none;
}

/* 4. Slot Button Styles*/

.slots-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-height: 250px;
    overflow-y: auto;
    padding-top: 5px;
}

.slot-btn {
    background-color: #fffaf0; /* Light gold background */
    color: var(--color-earth);
    padding: 10px 15px;
    border: 1px solid var(--color-gold);
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    transition: all 0.2s;
    flex-grow: 1;
    min-width: 130px;
}

/* Selected Button State */
.slot-btn.is-selected {
    background-color: var(--color-maroon);
    color: white;
    border-color: var(--color-maroon);
    box-shadow: 0 4px 10px rgba(93, 14, 31, 0.4);
}

.slot-btn:hover:not(.is-selected):not(:disabled) {
    background-color: var(--color-gold);
    border-color: var(--color-earth);
    color: var(--color-dark);
}

.slot-btn:disabled {
    background-color: #f8f8f8;
    color: #ccc;
    border-color: #eee;
    cursor: not-allowed;
    opacity: 0.7;
}

.no-slots-msg {
    color: var(--color-earth);
    font-style: italic;
    padding: 10px 0;
    font-size: 0.95rem;
}

.confirmation-modal {
    grid-column: 1 / span 2; 
    margin-top: 10px;
    padding: 25px;
    border: 3px solid var(--color-maroon); /* Strong Maroon border */
    border-radius: 10px;
    background-color: #fef8f9; /* Very light pink/maroon hint */
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.confirmation-modal h4 {
    margin-top: 0;
    color: var(--color-maroon);
    font-size: 1.5rem;
    border-bottom: 1px solid var(--color-gold);
    padding-bottom: 10px;
    margin-bottom: 15px;
    font-family: var(--font-serif);
}

.confirmation-modal p {
    margin-bottom: 15px;
    font-size: 1rem;
    color: #333;
}

/** Confirmation buttons */
.btn-confirm {
    background-color: #efbe63d5;
    color: var(--color-dark);
    padding: 15px 25px;
    border: none; 
    border-radius: 25px;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: bold;
    transition: all 0.3s, transform 0.2s;
    width: 100%;
}
.btn-cancel-small {
    background-color: #6c2e25d5;
    color: var(--color-dark);
    padding: 15px 25px;
    border: none; 
    border-radius: 25px;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: bold;
    transition: all 0.3s, transform 0.2s;
    width: 100%;
}
.modal-actions{
    display: flex;
    gap: 15px;
    margin-top: 30px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    align-items: center;
    flex-direction: column;
}

.input-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px;
}
.input-row label {
    font-weight: 600;
    color: var(--color-earth);
}

.time-input {
    padding: 10px;
    border: 1px solid var(--color-earth);
    border-radius: 6px;
    font-size: 1rem;
    width: 100%;
    box-sizing: border-box;
}

.confirmation-modal .btn-primary {
    background-color: var(--color-earth); /* Earth tone primary button */
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    margin-right: 10px;
    transition: background-color 0.2s;
}

.confirmation-modal .btn-primary:hover {
    background-color: #8c4722;
}

.confirmation-modal .btn-secondary-small {
    background-color: #eee;
    color: #555;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s;
}

/* Desktop View: Date and Time Side-by-Side */
@media (min-width: 650px) {
    .booking-form-grid {
        grid-template-columns: 1fr 1fr;
        gap: 30px;
    }

    .action-buttons-group {
        grid-column: 1 / span 2;
        flex-direction: row;
        justify-content: flex-end;
    }

    .submit-btn,
    .btn-secondary {
        width: auto;
        flex-grow: 0;
        min-width: 200px;
    }
    .modal-actions{
        /*flex-direction: row;*/
        grid-column: 1 / span 2;
        flex-direction: row;
        justify-content: flex-end;
    }
}

.service-placeholder-svg {
    width: 100%;
    height: 450px; /* Matching the max-height of the actual image */
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F9FAFB; /* Light grayscale background */
    border-bottom: 3px solid var(--color-gold); /* Keeping the theme line */
}

.service-placeholder-svg svg {
    width: 250px; /* Size it prominently for the detail view */
    height: 250px;
    opacity: 0.6;
}

/* Ensure the price tag stays on top of the placeholder too 
.header-content .service-detail-price {
    z-index: 20; 
}*/

/* Tablet/Mobile adjustment for the placeholder height */
@media (max-width: 768px) {
    .service-placeholder-svg {
        height: 300px; 
    }
    .service-placeholder-svg svg {
        width: 180px;
        height: 180px;
    }
}


</style>